import React from 'react';
import classnames from 'classnames';
import CSSclasses from '../../details.scss';
import SwitchButton from '../switch-button';
export function SwitchEmbellishmentMethodButton({
  method,
  productId,
  isDisabled,
  onMethodChange,
  shouldOpenDebossedPopup,
  showDebossedPopup,
  shouldOpenLaserEngravedPopup,
  showLaserEngravedPopup,
  mouseOnEmbellishmentMethod,
  mouseOutEmbellishmentMethod
}) {
  const handleClick = () => {
    if (isDisabled) {
      return;
    }
    if (shouldOpenDebossedPopup) {
      return showDebossedPopup(productId, method);
    }
    if (shouldOpenLaserEngravedPopup) {
      return showLaserEngravedPopup(productId, method);
    }
    onMethodChange(method);
  };
  return /*#__PURE__*/React.createElement(SwitchButton, {
    key: method.name,
    "data-button": method.name,
    onClick: handleClick,
    onMouseEnter: () => mouseOnEmbellishmentMethod(method),
    onMouseLeave: mouseOutEmbellishmentMethod,
    isActive: method.isActive,
    disabled: method.isDisabled,
    className: classnames(CSSclasses.button, {
      [CSSclasses.limitedEditionBtn]: method.isActiveLE,
      [CSSclasses.disabled]: isDisabled
    })
  }, method.name);
}